import React, { Fragment } from 'react'
import { FormInput, FormSubmit, FormWrapper } from '@myxplor/forms'
import withRemoteRequest from '../../remote-request'
import { withRouter } from 'react-router-dom'

const apiEndPoint = (serviceId) => `${process.env.REACT_APP_API_HOST}/api/iss_credentials/${serviceId}`

const defaultOnSubmit = ({ remote_request, serviceId }) => payload =>
  remote_request.submit(apiEndPoint(serviceId), {
    method: 'POST',
    jsonAPI: true,
    body: transformPayload(payload)
  })

const transformPayload = (payload) => {
  return {
    username: payload.ccms_username,
    password: payload.ccms_password,
    first_name: payload.first_name,
    last_name: payload.last_name,
    person_id: payload.person_id
  }
}

const transformDefaults = (defaultValues) => {
  return {
    ccms_username: defaultValues.username,
    ccms_password: defaultValues.password,
    first_name: defaultValues.first_name,
    last_name: defaultValues.last_name,
    person_id: defaultValues.person_id
  }
}

const defaults = {
  ccms_username: '',
  ccms_password: '',
  first_name: '',
  last_name: '',
  person_id: ''
}

export const PostISSCreds = ({
  formOptions = {},
  name = 'update_iss_creds',
  remote_request,
  onSubmit = defaultOnSubmit,
  serviceId,
  updateNewCreds,
  defaultValues = defaults
}) => {
  const { loading, success, data } = remote_request.state

  if (success) {
    // Set upstream state to response data
    updateNewCreds(data)
  }

  const errors = remote_request.state.errors

  return (
    <Fragment>
      <FormWrapper
        {...formOptions}
        onSubmit={onSubmit({ remote_request, name, serviceId })}
        defaultValues={transformDefaults(defaultValues ? defaultValues : defaults)}
        render={formProps => (
          <fieldset>
            <FormInput
              label="CCMS Username"
              name="ccms_username"
              value={formProps.values.ccms_username}
              required
              onChange={formProps.onChange}
              loading={loading}
              autoFocus
            />

            <FormInput
              label="CCMS Password"
              name="ccms_password"
              value={formProps.values.ccms_password}
              required
              onChange={formProps.onChange}
              loading={loading}
            />

            <FormInput
              label="Authorized Person First Name"
              name="first_name"
              value={formProps.values.first_name}
              required
              onChange={formProps.onChange}
              loading={loading}
            />

            <FormInput
              label="Authorized Person Last Name"
              name="last_name"
              value={formProps.values.last_name}
              required
              onChange={formProps.onChange}
              loading={loading}
            />


            <FormInput
              label="Authorized Person ID"
              name="person_id"
              value={formProps.values.person_id}
              required
              onChange={formProps.onChange}
              loading={loading}
            />

            <FormSubmit
              loading={loading}
              disabled={!formProps.valid}
              loadingTitle="Updating credentials..."
              errors={errors ? errors[0] : null}
            >
              Update ISS Credentials
            </FormSubmit>
          </fieldset>
        )}
      />
    </Fragment>
  )
}

export default withRouter(withRemoteRequest(PostISSCreds))


// WEBPACK FOOTER //
// ./src/iss-credentials-update/forms/postISSCreds.js